import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { editTopic } from "../../../redux/slice/topicSlice";

const EditTopicForm = ({ topic, setEditActive }) => {
  const dispatch = useDispatch();

  const [topicName, setTopicName] = useState(topic?.topicName);
  const [topicError, setTopicError] = useState("");

  const handleEditDone = async (e) => {
    e.preventDefault();
    if (topicName === topic.topicName) {
      setEditActive(false);
    } else {
      if (!topicName) {
        setTopicError("Required");
      } else {
        const data = { id: topic?._id, data: { topicName: topicName } };
        try {
          await dispatch(editTopic(data)).unwrap();
          setEditActive(false);
        } catch (err) {
          setTopicError(err.message);
        }
      }
    }
  };
  return (
    <form onSubmit={handleEditDone} className="flex flex-col">
      <div className="text-textPrimary flex flex-row gap-4 outline outline-1 outline-gray-500 rounded-[4px] px-4 h-8">
        <input
          type="text"
          id="subject"
          name="subject"
          value={topicName}
          onChange={(e) => {
            setTopicName(e.target.value);
            setTopicError("");
          }}
          onBlur={() => setEditActive(false)}
          className="w-full bg-transparent focus:outline-none"
          autoFocus
        />
        <button type="submit">
          <FaCheck />
        </button>
      </div>
      <span className="pl-4 text-[12px] italic text-red-500">{topicError}</span>
    </form>
  );
};

export default EditTopicForm;
